import { render, staticRenderFns } from "./quick_actions_component.vue?vue&type=template&id=7f2ad717&scoped=true"
import script from "./quick_actions_component.vue?vue&type=script&lang=js"
export * from "./quick_actions_component.vue?vue&type=script&lang=js"
import style0 from "./quick_actions_component.vue?vue&type=style&index=0&id=7f2ad717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ad717",
  null
  
)

export default component.exports